module.exports = __webpack_public_path__ + "o.no2.19df58ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/o.no2.jpg
// module id = afY4
// module chunks = 0